<template>
  <div class="setting_wrap" >
    <div class="setting_card" >
      <div class="setting_item" >
        <div>头像</div>
        <div>
          <img class="head_img right_between" :src="userVo.headImgUrl" />
<!--          <div class="right" ></div>-->
        </div>
      </div>

      <div class="setting_item" >
        <div>昵称</div>
        <div>
          <div class="setting_text right_between " >{{ userVo.nickName }}</div>
<!--          <div class="right" ></div>-->
        </div>
      </div>

      <div class="setting_item"  >
        <div>手机号</div>
        <div>
          <div class="setting_text right_between"  >{{ userVo.tel }}</div>
<!--          <div class="right" ></div>-->
        </div>
      </div>

<!--      <div class="setting_item" @click="poster" >
        <div>我的海报</div>
        <div>
          <div class="right" ></div>
        </div>
      </div>-->

<!--      <div class="setting_item" @click="setIdCard" >
        <div>身份证</div>
        <div>
          <div class="setting_text" >未设置</div>
          <div class="right" ></div>
        </div>
      </div>-->
    </div>

<!--    <div class="setting_card" >
      <div class="setting_item" @click="addressList" >
        <div>地址管理</div>
        <div>
          <div class="setting_text" >查看</div>
          <div class="right" ></div>
        </div>
      </div>

      <div class="setting_item" >
        <div>微信二维码</div>
        <div>
          <div class="setting_text" >查看</div>
          <div class="right" ></div>
        </div>
      </div>

      <div class="setting_item" >
        <div>社区二维码</div>
        <div>
          <div class="setting_text" >查看</div>
          <div class="right" ></div>
        </div>
      </div>
    </div>-->

    <div class="setting_card"  >
      <div class="setting_item" v-if="userVo.parentNickName" >
        <div>推荐人</div>
        <div>
          <div class="setting_text right_between" >{{ userVo.parentNickName }}</div>
        </div>
      </div>

      <div class="setting_item" >
        <div>会员编码</div>
        <div>
          <div class="setting_text right_between" >{{ userVo.userId }}</div>
        </div>
      </div>

      <div class="setting_item" >
        <div>加入时间</div>
        <div>
          <div class="setting_text right_between" >{{ userVo.createTime }}</div>
        </div>
      </div>

    </div>

    <div class="setting_card" >
      <div class="setting_item" @click="winnerRecord" >
        <div>中奖记录</div>
        <div>
          <div class="right" ></div>
        </div>
      </div>

      <div class="setting_item" @click="scoreList" >
        <div>积分记录</div>
        <div>
          <div class="right" ></div>
        </div>
      </div>

      <div class="setting_item" @click="toBank" >
        <div>银行卡管理</div>
        <div>
          <div class="right" ></div>
        </div>
      </div>
    </div>

    <div class="setting_card" >
<!--      <div class="setting_item" >
        <div>清除缓存</div>
        <div class="right" ></div>
      </div>-->

      <div class="setting_item" @click="logout" >
        <div>退出登录</div>
        <div class="right" ></div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getUserInfo } from '@/api/login'
import { Dialog } from "vant";

export default {
  name: 'setting',
  data() {
    return {
      userVo: {}
    }
  },
  methods: {
    toBank() {
      this.$router.push({ name: 'bank' })
    },
    scoreList() {
      this.$router.push({ name: 'scoreList' })
    },
    winnerRecord() {
      this.$router.push({ name: 'winningRecord' })
    },
    poster() {
      this.$router.push({ name: 'poster' })
    },
    logout() {
      Dialog.confirm({
        title: '提示',
        message: '是否退出登录?',
        confirmButtonColor: '#61b173'
      }).then(() => {
          localStorage.clear()
          window.location.reload()
      })
    },
    addressList() {
      this.$router.push({ name: 'addressList' })
    },
    setIdCard() {
      this.$router.push({ name: 'setIdCard' })
    },
    getUserInfo() {
      getUserInfo({}).then(res =>{
        console.log(res)
        if(res.success) {
          this.userVo = res.data.userVo
        }
      })
    }
  },
  mounted() {
    this.getUserInfo()
  }
}
</script>
